/* BLOUP · rediseño oct 2026: pack de 2 preseleccionado, barra fija de compra, nombres cortos en el carrito,
   galería de fotos de clientes con visor y aviso de hora de corte de despacho. */
(function () {
  'use strict';
  var CONFIG = { cutoffHour: 11, holidays: [] };
  try {
    var c = document.getElementById('bl-config');
    if (c) CONFIG = Object.assign(CONFIG, JSON.parse(c.textContent));
  } catch (e) {}

  function preselectPack() {
    if (new URLSearchParams(location.search).has('variant')) return;
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      var target = Array.prototype.find.call(vs.querySelectorAll('input[type=radio]'), function (i) {
        return /^2\s+unidad/i.test(i.value);
      });
      if (target && !target.checked && !target.classList.contains('disabled')) target.click();
    });
  }

  function cleanOptions() {
    document.querySelectorAll('.product-option').forEach(function (el) {
      if (el.dataset.blClean) return;
      var dd = el.querySelector('dd');
      var dt = el.querySelector('dt');
      var src = dd || el;
      var txt = (src.textContent || '').trim();
      /* Unidades sueltas: la cantidad del carrito ya dice cuántos envases son, así que no se repite "Pack: 1 unidad" */
      if (/^1\s+unidad$/i.test(txt)) { el.style.display = 'none'; el.dataset.blClean = '1'; return; }
      if (txt.indexOf('→') === -1) return;
      var short = txt.split('→')[0].replace(/\s+o más\s*$/i, '').trim();
      if (dd) { dd.textContent = short; if (dt) dt.textContent = 'Pack:'; } else { el.textContent = short; }
      el.dataset.blClean = '1';
    });
  }

  function stickyBar() {
    var bar = document.querySelector('[data-bl-sticky]');
    if (!bar) return;
    var custom = document.querySelector('[data-blp-buy]');
    var main = custom || document.querySelector('product-form .product-form__submit');
    if (!main) return;
    var priceEl = bar.querySelector('[data-bl-sticky-price]');
    var fmt = new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 });
    function refreshPrice() {
      if (custom) {
        var c = document.querySelector('[data-blp-form] input[name="quantity"]:checked, [data-blp-form] input[type="radio"][name="id"]:checked');
        if (c) priceEl.textContent = c.dataset.name + ' · ' + c.dataset.price;
        return;
      }
      var json = document.querySelector('variant-selects [data-selected-variant]');
      try {
        var v = JSON.parse(json.textContent);
        var name = (v.title || '').split('→')[0].replace(/\s+o más\s*$/i, '').trim();
        priceEl.textContent = name + ' · ' + fmt.format(v.price / 100);
      } catch (e) {}
    }
    document.addEventListener('blp:variant', refreshPrice);
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (show) refreshPrice();
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('bl-sticky-on', show);
    });
    io.observe(main);
    bar.querySelector('button').addEventListener('click', function () {
      if (custom) {
        var f = custom.form;
        if (f && f.requestSubmit) f.requestSubmit(custom); else custom.click();
        return;
      }
      var btn = document.querySelector('product-form .product-form__submit');
      if (btn && !btn.disabled) btn.click();
      else if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* Hora de corte de despacho (hora de Bogotá, UTC-5, días hábiles sin festivos) */
  var DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  function bogotaNow() {
    var d = new Date();
    return new Date(d.getTime() + d.getTimezoneOffset() * 60000 - 5 * 3600000);
  }
  function ymd(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function isBusinessDay(d) {
    var w = d.getDay();
    return w !== 0 && w !== 6 && CONFIG.holidays.indexOf(ymd(d)) === -1;
  }
  function cutoffText() {
    var now = bogotaNow();
    var limit = CONFIG.cutoffHour * 60;
    var mins = now.getHours() * 60 + now.getMinutes();
    if (isBusinessDay(now) && mins < limit) {
      var left = limit - mins;
      var h = Math.floor(left / 60), m = left % 60;
      var t = (h ? h + ' h ' : '') + m + ' min';
      return 'Pide en las próximas <strong>' + t + '</strong> y lo despachamos <strong>hoy</strong>.';
    }
    var next = new Date(now.getTime());
    for (var i = 0; i < 15; i++) {
      next.setDate(next.getDate() + 1);
      if (isBusinessDay(next)) break;
    }
    var diff = Math.round((new Date(ymd(next)) - new Date(ymd(now))) / 86400000);
    var when = diff === 1 ? 'mañana' : 'el ' + DAYS[next.getDay()];
    return 'Pide hoy y lo despachamos <strong>' + when + '</strong>. Pedidos antes de las ' + CONFIG.cutoffHour + ':00 a. m. salen el mismo día.';
  }
  function cutoff() {
    var lines = document.querySelectorAll('.bl-shipline');
    if (!lines.length) return;
    var icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
    var nodes = [];
    lines.forEach(function (line) {
      if (line.nextElementSibling && line.nextElementSibling.classList.contains('bl-cutoff')) return;
      var p = document.createElement('p');
      p.className = 'bl-cutoff';
      p.innerHTML = icon + '<span></span>';
      line.insertAdjacentElement('afterend', p);
      nodes.push(p);
    });
    function paint() {
      var html = cutoffText();
      document.querySelectorAll('.bl-cutoff span').forEach(function (s) { s.innerHTML = html; });
    }
    paint();
    setInterval(paint, 60000);
  }

  /* Galería de fotos de clientes con visor */
  function gallery() {
    function show(dlg, i) {
      var items = dlg._items;
      dlg._idx = (i + items.length) % items.length;
      dlg.querySelector('img').src = items[dlg._idx].dataset.src;
      dlg.querySelector('[data-bl-count]').textContent = (dlg._idx + 1) + ' / ' + items.length;
    }
    document.addEventListener('click', function (ev) {
      var more = ev.target.closest('[data-bl-more]');
      if (more) {
        more.closest('.bl-photos').querySelector('.bl-photos__grid').classList.add('is-open');
        more.parentElement.hidden = true;
        return;
      }
      var btn = ev.target.closest('[data-bl-photo]');
      if (!btn) return;
      var wrap = btn.closest('.bl-photos');
      var dlg = wrap && wrap.querySelector('[data-bl-lightbox]');
      if (!dlg || typeof dlg.showModal !== 'function') return;
      dlg._items = Array.prototype.slice.call(wrap.querySelectorAll('[data-bl-photo]'));
      if (!dlg.dataset.ready) {
        dlg.dataset.ready = '1';
        dlg.querySelector('[data-bl-prev]').addEventListener('click', function () { show(dlg, dlg._idx - 1); });
        dlg.querySelector('[data-bl-next]').addEventListener('click', function () { show(dlg, dlg._idx + 1); });
        dlg.querySelector('[data-bl-close]').addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
        dlg.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') show(dlg, dlg._idx - 1);
          if (e.key === 'ArrowRight') show(dlg, dlg._idx + 1);
        });
      }
      show(dlg, dlg._items.indexOf(btn));
      dlg.showModal();
    });
  }

  function init() {
    preselectPack();
    cleanOptions();
    stickyBar();
    cutoff();
    gallery();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(cleanOptions, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();